import React, { useState, useEffect, useRef } from 'react';
import Select from 'react-select';

const findOption = (val, options) => {
  if (val === null || val === undefined || !options) return null;
  // If val is already an option object
  if (typeof val === 'object' && val !== null && 'value' in val) return val;
  // Find by value (exact match or stringified comparison)
  let found = options.find((opt) => String(opt.value) === String(val));
  if (found) return found;
  // Find by label (case-insensitive)
  found = options.find((opt) => String(opt.label).toUpperCase() === String(val).toUpperCase());
  return found || null;
};

const RSelect = ({ defaultValue, value, ...props }) => {
  const [internalValue, setInternalValue] = useState(() =>
    findOption(value !== undefined ? value : defaultValue, props.options)
  );

  const prevDefaultValueRef = useRef(defaultValue);
  const prevValueRef = useRef(value);
  const prevOptionsRef = useRef(props.options);

  useEffect(() => {
    // If defaultValue or options changed, update the internal value
    if (defaultValue !== prevDefaultValueRef.current || props.options !== prevOptionsRef.current) {
      setInternalValue(findOption(defaultValue, props.options));
      prevDefaultValueRef.current = defaultValue;
      prevOptionsRef.current = props.options;
    }
  }, [defaultValue, props.options]);

  useEffect(() => {
    // If controlled value or options changed, update the internal value
    if (value !== prevValueRef.current || props.options !== prevOptionsRef.current) {
      setInternalValue(findOption(value, props.options));
      prevValueRef.current = value;
      prevOptionsRef.current = props.options;
    }
  }, [value, props.options]);

  const handleOnChange = (val, actionMeta) => {
    setInternalValue(val);
    if (props.onChange) {
      props.onChange(val, actionMeta);
    }
  };

  return (
    <div className="form-control-select">
      <Select
        className={`react-select-container ${
          props.className ? props.className : ''
        }`}
        classNamePrefix="react-select"
        value={internalValue}
        onChange={handleOnChange}
        {...props}
      />
    </div>
  );
};

export default RSelect;
